import React from "react";
import * as S from "./userInfoPageContent.styles";
import { MainProfileImg } from "../../atoms/MainProfileImg";
import { InfoForm } from "../../molcules/InfoForm";
import { ReactComponent as IconInfoEdit } from "../../../styles/assets/svg/icon-info-edit.svg";
import { ReactComponent as IconCamera } from "../../../styles/assets/svg/icon-camera-white.svg";

interface UserInfoPageContentProps {
  data: any;
  inputRef: React.MutableRefObject<HTMLInputElement>;
  onEditPagesMoveHanlder: () => void;
  onImgSelect: () => void;
  onChangeImg: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const UserInfoPageContent = ({
  data,
  inputRef,
  onEditPagesMoveHanlder,
  onImgSelect,
  onChangeImg,
}: UserInfoPageContentProps) => {
  return (
    <S.InfoContent>
      <S.Profile>
        <S.MainProfileSection>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={onChangeImg}
          />
          <S.MainProfileImgLayout onClick={onImgSelect}>
            {!data.profileImg ? (
              <MainProfileImg width={81} height={81} />
            ) : (
              <S.MainProfileBox>
                <img
                  src={`${process.env.REACT_APP_API_HOST}${data.profileImg.imageUrl}`}
                  alt="profile"
                />
              </S.MainProfileBox>
            )}
            <S.MainProfileImgCameraBox>
              <IconCamera width={18} height={18} />
            </S.MainProfileImgCameraBox>
          </S.MainProfileImgLayout>
          <S.ProfileTxtBox>
            <S.UserAuthSpan>기사회원</S.UserAuthSpan>
            <S.UserStatusBox>
              <S.UserNameText>{data.username}</S.UserNameText>
              <S.UserInfoEditButtonBox onClick={onEditPagesMoveHanlder}>
                <IconInfoEdit />
                <p>수정</p>
              </S.UserInfoEditButtonBox>
            </S.UserStatusBox>
          </S.ProfileTxtBox>
        </S.MainProfileSection>
      </S.Profile>
      <InfoForm data={data.profile} />
    </S.InfoContent>
  );
};
